import React, { useState } from "react";
import "./App.css";

const App: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  const toggleMenu = (): void => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuClose = (): void => {
    setIsMenuOpen(false);
  };

  const handleOrderClick = (): void => {
    window.open('https://rzp.io/rzp/6EMoofW', '_blank');
  };



  return (
    <div className="App">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="nav-brand">
            <div className="logo-container">
              <img src="/assets/aronandhi-logo.jpg" alt="AroNandhi Logo" className="logo-image" />
              <div className="brand-text">
                <h2>AroNandhi</h2>
                <span className="brand-subtitle">SSSGN TECHTEX</span>
              </div>
            </div>
          </div>
          <nav className={`nav ${isMenuOpen ? "nav-open" : ""}`}>
            <a href="#home" onClick={handleMenuClose}>
              Home
            </a>
            <a href="#products" onClick={handleMenuClose}>
              Products
            </a>
            <a href="#about" onClick={handleMenuClose}>
              About
            </a>
            <a href="#contact" onClick={handleMenuClose}>
              Contact
            </a>
          </nav>
          <button className="menu-toggle" onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </header>
      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>AroNandhi Neem Sanitary Napkins</h1>
            <h2 className="hero-tagline">Ayurveda's Care for Every Woman</h2>
            <p>
              AroNandhi Neem Sanitary Napkins are an Ayurveda-based innovation designed to support
              women's reproductive health through every menstrual cycle. Each pad is made using
              100% Indian-sourced raw materials and infused with the healing power of Neem
              (Azadirachta indica) — a sacred herb in Ayurveda known for its antibacterial,
              antifungal, and detoxifying properties.
            </p>
            <p>
              Unlike ordinary chemical-based sanitary pads, AroNandhi Neem Napkins are free from
              dioxin, chlorine, artificial fragrance, and harmful chemicals. This ensures no
              hormonal disturbance, no rash, no irritation, and complete comfort even during
              long hours of use.
            </p>
            <div className="hero-buttons">
              <button className="cta-button shop-now" onClick={handleOrderClick}>Shop Now</button>
              <button className="cta-button secondary" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>Get In Touch</button>
            </div>
          </div>
          <div className="hero-image">
            <div className="hero-logo-display">
              <img src="/assets/aronandhi-logo.jpg" alt="AroNandhi Logo" className="hero-logo-image" />
              <div className="hero-brand-name">AroNandhi</div>
            </div>
            <div className="hero-images-grid">
              <img src="/assets/1.jpg" alt="AroNandhi Product 1" className="hero-grid-image" />
              <img src="/assets/2.jpg" alt="AroNandhi Product 2" className="hero-grid-image" />
              <img src="/assets/3.jpg" alt="AroNandhi Product 3" className="hero-grid-image" />
            </div>
          </div>
        </div>
      </section>
      {/* Health Benefits Section */}
      <section id="products" className="products">
        <div className="container">
          <h2>How AroNandhi Helps in Preventing Women's Health Issues</h2>
          <p className="section-subtitle">Hover over each card to learn more</p>
          <button className="cta-button order-now" onClick={handleOrderClick}>Order Now</button>

          <div className="health-issues-grid">
            <div className="health-issue-card">
              <div className="issue-header">
                <h3>Irregular Periods</h3>
              </div>
              <div className="issue-images">
                <img src="/assets/4.jpg" alt="Irregular Periods Solution" className="issue-image" />
              </div>
              <div className="issue-content">
                <p className="issue-problem">
                  Irregular periods often occur due to hormonal imbalance and exposure to
                  chemical-based pads that interfere with the body's endocrine system.
                </p>
                <p className="issue-solution">
                  AroNandhi Neem Napkins are made with chemical-free natural fibers and Ayurvedic
                  herbal infusion that help maintain hormonal balance and support regular menstrual flow.
                  The cooling and cleansing properties of Neem reduce uterine heat, helping to normalize
                  the cycle naturally.
                </p>
              </div>
            </div>

            <div className="health-issue-card">
              <div className="issue-header">
                <h3>PCOD & PCOS</h3>
              </div>
              <div className="issue-images">
                <img src="/assets/5.jpg" alt="PCOD & PCOS Solution" className="issue-image" />
              </div>
              <div className="issue-content">
                <p className="issue-problem">
                  Polycystic Ovary Disorders (PCOD/PCOS) are commonly linked to toxin accumulation
                  and hormone disruption.
                </p>
                <p className="issue-solution">
                  Using AroNandhi Neem Napkins regularly helps reduce chemical exposure and promotes
                  detoxification through Neem's purifying effect. The pads' natural antibacterial action
                  keeps the reproductive area infection-free, while their gentle Ayurvedic support helps
                  stabilize hormonal activity over time.
                </p>
              </div>
            </div>

            <div className="health-issue-card">
              <div className="issue-header">
                <h3>Infertility</h3>
              </div>
              <div className="issue-images">
                <img src="/assets/6.jpg" alt="Infertility Solution" className="issue-image" />
              </div>
              <div className="issue-content">
                <p className="issue-problem">
                  Infertility can result from chronic inflammation, uterine infections, and
                  hormonal imbalances.
                </p>
                <p className="issue-solution">
                  Neem's anti-inflammatory and cleansing nature helps purify the reproductive system,
                  improve uterine health, and support natural fertility. By preventing repeated exposure
                  to toxins and synthetic chemicals (commonly found in regular pads), AroNandhi Neem
                  Napkins help preserve the body's natural reproductive functions.
                </p>
              </div>
            </div>

            <div className="health-issue-card">
              <div className="issue-header">
                <h3>Cancer (Reproductive & Cervical)</h3>
              </div>
              <div className="issue-images">
                <img src="/assets/7.jpg" alt="Cancer Prevention" className="issue-image" />
              </div>
              <div className="issue-content">
                <p className="issue-problem">
                  Most commercial pads release dioxins, a harmful by-product of bleaching, which is
                  known to cause cellular mutation and cancer risk.
                </p>
                <p className="issue-solution">
                  AroNandhi Neem Napkins are 100% dioxin-free and made with organic, unbleached, and
                  non-toxic materials, ensuring no chemical accumulation in the body. Neem's natural
                  antioxidants further help in neutralizing free radicals, thereby reducing the long-term
                  risk of reproductive and cervical cancers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Features & Why Choose Section */}
      <section id="about" className="about">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>Key Features</h2>

              <div className="features">
                <div className="features-row top-row">
                  <div className="feature">
                    <div className="feature-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z" />
                      </svg>
                    </div>
                    <div className="feature-content">
                      <h4>Ayurveda-based & Neem-infused</h4>
                      <p>Herbal protection rooted in ancient Ayurvedic wisdom</p>
                    </div>
                    <div className="feature-glow"></div>
                  </div>
                  <div className="feature">
                    <div className="feature-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                      </svg>
                    </div>
                    <div className="feature-content">
                      <h4>No Harmful Chemicals</h4>
                      <p>Free from dioxin, chlorine, and artificial fragrances</p>
                    </div>
                    <div className="feature-glow"></div>
                  </div>
                  <div className="feature">
                    <div className="feature-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" />
                      </svg>
                    </div>
                    <div className="feature-content">
                      <h4>No Rash, Irritation or Odor</h4>
                      <p>Gentle protection that keeps you comfortable all day</p>
                    </div>
                    <div className="feature-glow"></div>
                  </div>
                </div>
                <div className="features-row bottom-row">
                  <div className="feature">
                    <div className="feature-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                      </svg>
                    </div>
                    <div className="feature-content">
                      <h4>Maintains Hormonal Balance</h4>
                      <p>Supports your body's natural hormonal rhythm</p>
                    </div>
                    <div className="feature-glow"></div>
                  </div>
                  <div className="feature">
                    <div className="feature-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M7 2v11h3v9l7-12h-4l4-8z" />
                      </svg>
                    </div>
                    <div className="feature-content">
                      <h4>Soft, Breathable & Absorbent</h4>
                      <p>Ultra-comfortable with superior absorption technology</p>
                    </div>
                    <div className="feature-glow"></div>
                  </div>
                  <div className="feature">
                    <div className="feature-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M17.66 8L12 2.35 6.34 8A8.02 8.02 0 004 13.64c0 2 .78 4.11 2.34 5.67a7.99 7.99 0 0011.32 0c1.56-1.56 2.34-3.67 2.34-5.67 0-2.23-1-4.35-2.34-5.64z" />
                      </svg>
                    </div>
                    <div className="feature-content">
                      <h4>100% Indian-made Materials</h4>
                      <p>Supporting local resources and sustainability</p>
                    </div>
                    <div className="feature-glow"></div>
                  </div>
                  <div className="feature">
                    <div className="feature-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z M12 5.84L7.15 18.5 12 16.15l4.85 2.35z" />
                      </svg>
                    </div>
                    <div className="feature-content">
                      <h4>Eco-friendly & Biodegradable</h4>
                      <p>Caring for you and the planet</p>
                    </div>
                    <div className="feature-glow"></div>
                  </div>
                </div>
              </div>

              <div className="why-choose-section">
                <h2>Why Choose AroNandhi Neem Sanitary Napkins</h2>
                <div className="why-choose-images">
                  <img src="/assets/8.jpg" alt="AroNandhi Quality" className="why-choose-image" />
                  <img src="/assets/9.jpg" alt="AroNandhi Care" className="why-choose-image" />
                </div>
                <p className="why-choose-text">
                  AroNandhi is not just a sanitary napkin — it's an <strong>Ayurvedic wellness product</strong>
                  designed to protect, heal, and balance a woman's body naturally.
                </p>
                <p className="why-choose-text">
                  By using safe, herbal, and eco-friendly materials, AroNandhi supports long-term reproductive
                  health, helping women live a pain-free, confident, and healthy life — the Ayurvedic way.
                </p>
                <div className="tagline-box">
                  <h3>AroNandhi Neem Sanitary Napkins</h3>
                  <p className="tagline-emphasis">Prevent Better Than Cure</p>
                  <p className="tagline-subtitle">Nature's Protection for Every Woman</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Section */}
      <section id="contact" className="contact">
        <div className="container">
          <h2>Get In Touch</h2>
          <div className="contact-content">
            <div className="contact-info-centered">
              <h3>Contact Information</h3>
              <div className="contact-grid">
                <div className="contact-item">
                  <div className="contact-icon">📧</div>
                  <div className="contact-details">
                    <strong>Email</strong>
                    <p>sssgntechtex@gmail.com</p>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="contact-icon">📞</div>
                  <div className="contact-details">
                    <strong>Phone</strong>
                    <p>90253 00354</p>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="contact-icon">📍</div>
                  <div className="contact-details">
                    <strong>Address</strong>
                    <p>SSSGN TECHTEX<br />
                      48, Tirupugazh Samy Street,<br />
                      Kangayanallur, Vellore - 632006</p>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="contact-icon">🕒</div>
                  <div className="contact-details">
                    <strong>Business Hours</strong>
                    <p>Monday - Friday: 9:00 AM - 6:00 PM<br />
                      Saturday: 10:00 AM - 4:00 PM</p>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="contact-icon">🛒</div>
                  <div className="contact-details">
                    <strong>For Orders & Queries</strong>
                    <p>Contact No: 90253 00354</p>
                  </div>
                </div>
              </div>

              {/* Social Media Links */}
              <div className="contact-social">
                <h3>Follow Us</h3>
                <div className="social-links-contact">
                  <a href="https://www.facebook.com/profile.php?id=61582631241793" target="_blank" rel="noopener noreferrer" className="social-link facebook">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                    </svg>
                    <span>Facebook</span>
                  </a>
                  <a href="https://www.instagram.com/aronandhi/?hl=en" target="_blank" rel="noopener noreferrer" className="social-link instagram">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                    <span>Instagram</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <div className="footer-logo">
                <img src="/assets/aronandhi-logo.jpg" alt="AroNandhi Logo" className="footer-logo-image" />
                <div className="footer-brand">
                  <h3>AroNandhi</h3>
                  <span className="footer-subtitle">SSSGN TECHTEX</span>
                </div>
              </div>
              <p>
                Experience superior menstrual hygiene with our Neem-Infused Sanitary Pads.
                Stay fresh, protected, and worry-free with the power of nature.
              </p>
            </div>
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                <li>
                  <a href="#home">Home</a>
                </li>
                <li>
                  <a href="#products">Products</a>
                </li>
                <li>
                  <a href="#about">About</a>
                </li>
                <li>
                  <a href="#contact">Contact</a>
                </li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Connect With Us</h4>
              <div className="social-links">
                <a href="https://www.facebook.com/profile.php?id=61582631241793" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="social-icon facebook">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a>
                <a href="https://www.instagram.com/aronandhi/?hl=en" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="social-icon instagram">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 AroNandhi. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;
